import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Switch, Route } from "react-router-dom";
import * as appActions from "../../_actions/appActions";
import isUserLoggedIn from "../../_selectors/userSelectors/isUserLoggedIn";

import Layout from "../Layout";
import Home from "../../_components/Home";
import Profile from "../../_components/Profile";
import Search from "../../_components/Search";
import ViewProfile from "../../_components/ViewProfile";
import Matches from "../../_components/Matches";
import PendingInvitations from "../../_components/PendingInvitations";
import AcceptInvitations from "../../_components/AcceptInvitations";
import LikedMe from "../../_components/LikedMe";
import InterestedInMe from "../../_components/InterestedInMe";
import RecentlyViewed from "../../_components/RecentlyViewed";
import ProfileVisitors from "../../_components/ProfileVisitors";
import ConnectedMembers from "../../_components/ConnectedMembers";
import Notifications from "../../_components/Notifications";
import Gallery from "../../_components/Gallery";
import NotFound from "../../_components/NotFound";
import FAQ from "../../_components/FAQ";
import Settings from "../../_components/Settings";
class Protected extends Component {
  render() {
    const { isLoggedIn, updateBreadcrumb, updateHeader } = this.props;
    if (isLoggedIn) {
      return (
        <Layout>
          <Switch>
            <Route
              path="/"
              exact
              render={props => (
                <Home
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path="/profile"
              render={({ match }) => (
                <Profile
                  match={match}
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path="/search"
              render={({ match }) => (
                <Search
                  match={match}
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />

            <Route
              path="/view-profile"
              render={({ match }) => (
                <ViewProfile
                  match={match}
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path="/my-activity"
              render={({ match }) => (
                <Matches
                  match={match}
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path="/invitations-sent"
              exact
              render={({ match }) => (
                <PendingInvitations
                  match={match}
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path="/invitations-received"
              exact
              render={({ match }) => (
                <AcceptInvitations
                  match={match}
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path="/people-who-liked-me"
              exact
              render={({ match }) => (
                <LikedMe
                  match={match}
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path="/people-expressed-interest-in-me"
              exact
              render={({ match }) => (
                <InterestedInMe
                  match={match}
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path={`/recently-viewed`}
              exact
              render={props => (
                <RecentlyViewed
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path={`/profile-visitors`}
              exact
              render={props => (
                <ProfileVisitors
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path={`/connected-members`}
              exact
              render={props => (
                <ConnectedMembers
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path={`/notifications`}
              exact
              render={props => (
                <Notifications
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path={`/gallery`}
              exact
              render={props => (
                <Gallery
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path={`/frequently-asked-questions`}
              exact
              render={props => (
                <FAQ
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
            <Route
              path={`/settings`}
              exact
              render={({ history }) => (
                <Settings
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                  history={history}
                />
              )}
            />
            <Route
              render={props => (
                <NotFound
                  updateHeader={updateHeader}
                  updateBreadcrumb={updateBreadcrumb}
                />
              )}
            />
          </Switch>
        </Layout>
      );
    } else {
      return <Redirect to="/login" />;
    }
  }
}

const mapStateToProps = (state, ownProps) => ({
  isLoggedIn: isUserLoggedIn(state)
});
const mapDispatchToProps = dispatch => ({
  updateHeader: payload => dispatch(appActions.updatePageHeader(payload)),
  updateBreadcrumb: payload =>
    dispatch(appActions.updateBreadcrumbMenuItems(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Protected);



// WEBPACK FOOTER //
// ./src/_hoc/Protected/index.js